import { BASE_ASSETS } from "@assets/templates/constants";
import type { ComposeTemplate } from "@assets/templates/types";

export const treeTreatmentExample: ComposeTemplate = {
  mode: "compose",
  slug: "tree-treatment-example",
  version: 1,
  title: "Tree care",
  description: "Research treatment options",
  subdescription: "Use visual clues and web search to help a tree recover",
  thumbnailUuid: BASE_ASSETS.treeDetail.uuid,
  assets: [BASE_ASSETS.treeDetail],
  featured: true,
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.treeDetail.uuid,
              extension: BASE_ASSETS.treeDetail.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Can you help determine the best way to treat this tree?" },
      },
    ],
    temperature: 0,
    outputAnnotations: false,
    variables: {},
    annotationFormat: null,
    enableThinking: true,
    tools: ["search"],
  },
};
